import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SubmitContactUsFormRequest } from '../api/models/submit-contact-us-form-request';
import { ContactUsService as SupportService } from '../api/services/contact-us.service';

@Injectable({
  providedIn: 'root',
})
export class ContactUsService {
  private actionSource = new BehaviorSubject('');
  currentAction = this.actionSource.asObservable();

  constructor(private supportService: SupportService) {}

  contactUs(contactRequest: SubmitContactUsFormRequest): Observable<boolean> {
    const contactResponse$ = this.supportService
      .supportApiContactusPost$Response({ body: contactRequest })
      .pipe(
        catchError((err: HttpErrorResponse) => {
          console.error(err);

          return of({
            body: null,
            ok: err.ok,
            status: err.status,
            statusText: err.statusText,
            url: err.url,
          } as HttpResponse<false>);
        }),

        map((response) => response.ok)
      );
    return contactResponse$;
  }

  changeCurrentAction(action: string) {
    this.actionSource.next(action);
  }
}
